import { Box, Container, Typography, Grid } from "@mui/material";
import { useEffect, useRef, useState } from "react";

import calidad from "../../assets/img/calidad.png";
import birrete from "../../assets/img/birrete.png";
import idea from "../../assets/img/idea.png";
import lista from "../../assets/img/lista.png";


const valores = [
  {
    img: calidad,
    title1:"Desarrollo",
    title2:"Integral"
  },
  {
    img: birrete,
    title1:"Años en la",
    title2:"Educación"
  },
  {
    img: idea,
    title1:"Valores en la",
    title2:"Comunidad"
  },
  {
    img: lista,
    title1:"Infraestructura",
    title2:"Necesaria"
  }
];



export const ValoresHome = () => {


const sectionRef = useRef(null);

const [visible,setVisible] = useState(false);



useEffect(()=>{


const observer = new IntersectionObserver(

([entry])=>{


if(entry.isIntersecting){

setVisible(true);

}else{

setVisible(false);

}


},

{
threshold:.25
}

);



if(sectionRef.current){

observer.observe(sectionRef.current);

}



return ()=>observer.disconnect();



},[]);





return (

<Box

ref={sectionRef}

sx={{

background:"#8f1515",

width:"100%",

display:"flex",

alignItems:"center",

justifyContent:"center",

overflow:"hidden",

opacity:visible?1:0,

transform:visible
?
"translateY(0)"
:
"translateY(60px)",


transition:"1s ease",
pt:10,pb:10


}}

>


<Container

maxWidth="lg"

sx={{

pt:12,

pb:12

}}

>



{/* TITULO */}

<Box

sx={{

display:"flex",

alignItems:"center",

justifyContent:"center",

mb:10,


opacity:visible?1:0,

transform:visible
?
"translateY(0)"
:
"translateY(-30px)",


transition:"1s ease"


}}

>


<Typography

sx={{

color:"#fff",

fontWeight:700,

textAlign:"center",

fontSize:{

xs:"1.8rem",

md:"2.5rem"

}

}}

>

¿POR QUÉ ELEGIRNOS?

</Typography>


</Box>







<Grid

container

spacing={5}

sx={{

display:"flex",

alignItems:"center",

justifyContent:"center"

}}

>


{

valores.map((item,index)=>(


<Grid

key={index}

size={{

xs:12,

sm:6,

md:4,

lg:3

}}

>


<Box

sx={{

display:"flex",

alignItems:"center",

justifyContent:"center",

flexDirection:"column",

textAlign:"center",

px:2,


opacity:visible?1:0,


transform:visible

?

"translateY(0) scale(1)"

:

"translateY(50px) scale(.8)",


transition:"1s ease",


transitionDelay:`${index*.25}s`


}}

>




{/* ICONO */}

<Box

sx={{

width:110,

height:110,

borderRadius:"50%",

display:"flex",

alignItems:"center",

justifyContent:"center",

mb:1,


animation:visible
?
"floatIcon 4s ease-in-out infinite"
:
"none"


}}

>


<Box

component="img"

src={item.img}

alt={item.title1}

sx={{

width:190

}}


/>


</Box>







<Typography

sx={{

color:"#fff",

fontWeight:500,

fontSize:{

xs:"1.4rem",

md:"1.5rem"

}

}}

>

{item.title1}

</Typography>




<Typography

sx={{

color:"#fff",

fontWeight:500,

fontSize:{

xs:"1.4rem",

md:"1.5rem"

}

}}

>

{item.title2}

</Typography>



</Box>


</Grid>


))


}


</Grid>




</Container>





<style>

{`

@keyframes floatIcon{

0%{

transform:translateY(0px);

}


50%{

transform:translateY(-8px);

}


100%{

transform:translateY(0px);

}

}

`}


</style>





</Box>


);


};